var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPassword(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7557 7.96807H5.52255V6.2848C5.52255 3.99106 7.37506 2.12388 9.65332 2.12388C11.9316 2.12388 13.7841 3.99361 13.7841 6.28991C13.7841 6.60153 14.0324 6.85185 14.3416 6.85185C14.6508 6.85185 14.8991 6.60153 14.8991 6.28991C14.8991 3.37292 12.5448 1 9.65332 1C8.2519 1 6.93411 1.54917 5.94323 2.54789C4.95235 3.54662 4.4075 4.87229 4.4075 6.2848V7.96807H3.23163C2.54739 7.96807 2 8.5198 2 9.2069V17.7407C2 18.4304 2.54992 19 3.23163 19H15.7532C16.4374 19 17 18.4304 17 17.7407V9.2069C17.0025 8.5198 16.4399 7.96807 15.7557 7.96807ZM15.8875 17.7535C15.8875 17.8225 15.8317 17.8787 15.7633 17.8787H3.23923C3.1708 17.8787 3.11505 17.8225 3.11505 17.7535V9.21711C3.11505 9.14815 3.1708 9.09195 3.23923 9.09195H15.7608C15.8292 9.09195 15.8849 9.14815 15.8849 9.21711V17.7535H15.8875Z",
    fill: "#8F9AAF",
    stroke: "#8F9AAF",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11C8.67 11 8 11.5207 8 12.1658C8 12.5907 8.29333 12.9637 8.73333 13.1684V15.4301C8.73333 15.7435 9.06333 16 9.46667 16C9.87 16 10.2 15.7435 10.2 15.4301V13.1969C10.6767 13.0026 11 12.614 11 12.1658C11 11.5207 10.33 11 9.5 11Z",
    fill: "#8F9AAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPassword);
export default __webpack_public_path__ + "static/media/user-password.602d26b940aad2d4e129f80b3243b621.svg";
export { ForwardRef as ReactComponent };